import axios from 'axios';

const BASE = process.env.REACT_APP_API_URL ?? '/api';

const authHeaders = () => ({
  headers: { Authorization: `Bearer ${localStorage.getItem('token') ?? ''}` },
});

export interface PaymentUrlResponse {
  payment_url: string;
}

/** Create a Robokassa payment order for a single color.
 *  returnPath is the frontend path to return to after payment (e.g. /game/42).
 *  Returns the payment URL to redirect the browser to. */
export const createColorPayment = (color: string, returnPath?: string) =>
  axios.post<PaymentUrlResponse>(
    `${BASE}/payment/color`,
    { color, return_path: returnPath ?? '' },
    authHeaders(),
  );

/** Create a Robokassa payment order for a monthly subscription.
 *  Returns the payment URL to redirect the browser to. */
export const createSubscriptionPayment = () =>
  axios.post<PaymentUrlResponse>(
    `${BASE}/payment/subscription`,
    {},
    authHeaders(),
  );
